export default {
  apiKey: "AIzaSyDZu_C0Qm0EaBLSPOIxH3fNK97ry8oXxBU",
  authDomain: "peopleready-ds.firebaseapp.com",
  databaseURL: "https://peopleready-ds.firebaseio.com",
  projectId: "peopleready-ds",
  storageBucket: "peopleready-ds.appspot.com",
  messagingSenderId: "917802447816",
  appId: "1:917802447816:web:3e4f241f9a80989c5786fd",
};
